import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AppBundle } from 'api/optimalprint-sdk.d';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { Store } from 'store';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import getCategoryId from 'store/category/selector/getCategoryId';
import { PricesToFetch } from 'store/price/types';
import { setFrameUpsellDataAction } from '../slice';
import getPredesignedProductItem from '../selector/getPredesignedProductItem';
import getEncPublicDesignId from '../selector/getEncPublicDesignId';

const fetchFrameUpsellDataOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const productItem = getPredesignedProductItem(store);
    if (!productItem) {
      return;
    }
    const encPublicDesignId = productItem?.encDesignId;

    let response;
    try {
      response = (await apiRequest(
        endpoints.upsellV1Screen,
        {
          designId: encPublicDesignId,
        },
        HttpMethods.GET,
        'data',
      )) as AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response;

      if (!response) {
        throw new Error('No response');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Cannot fetch editor screen upsell data');
      return;
    }
    const upsellData = response.items.length > 0 ? response : undefined;
    dispatch(setFrameUpsellDataAction(upsellData));

    if (!upsellData) {
      return;
    }

    // apply voucher
    try {
      await apiRequest(
        endpoints.cartV1VoucherAdd,
        {
          code: response.voucher,
        },
        HttpMethods.POST,
        'data',
      );
      // eslint-disable-next-line no-empty
    } catch {
      // eslint-disable-next-line no-console
      console.error('Error applying voucher code');
    }

    const pricesToUpdate: PricesToFetch = {};
    upsellData.items.forEach((item) => {
      const itemCategoryId = item.categoryId || getCategoryId(store);
      if (!itemCategoryId) {
        return;
      }

      if (!pricesToUpdate[itemCategoryId]) {
        pricesToUpdate[itemCategoryId] = {
          categoryId: Number(itemCategoryId),
          productIds: [],
          encryptedDesignId: getEncPublicDesignId(store) || '',
        };
      }
      pricesToUpdate[itemCategoryId].productIds.push(item.productId);
    });
    dispatch(setPricesToFetchOperation(pricesToUpdate));
    await dispatch(fetchPricesOperation());
  };

export default fetchFrameUpsellDataOperation;
